import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SelectBox } from '../../molecules/select-box';
import { SpotRegion } from '../../shared';

const options = [
  {
    label: <FormattedMessage id="spot.region.cz" defaultMessage="CZ" />,
    value: SpotRegion.CZ,
  },
  {
    label: <FormattedMessage id="spot.region.nl" defaultMessage="NL" />,
    value: SpotRegion.NL,
  },
  {
    label: <FormattedMessage id="spot.region.sk" defaultMessage="SK" />,
    value: SpotRegion.SK,
  },
];

export const SpotRegionSelect = () => {
  return (
    <SelectBox
      title={
        <FormattedMessage id="settings.spot.region" defaultMessage="Region" />
      }
      selectVariableId="SP_REGION"
      options={options}
      fullWidth
    />
  );
};
